import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "variant"];
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { ButtonContent } from './ButtonContent';
import { IconContainer } from '../Icons/IconContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const ButtonLoading = _ref => {
  let {
      children,
      variant = 'primary'
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  return /*#__PURE__*/_jsx(LoadingButton, Object.assign({}, rest, spacingProps, {
    use: variant,
    children: /*#__PURE__*/_jsx(ButtonContent, {
      children: children
    })
  }));
};
ButtonLoading.Icon = props => /*#__PURE__*/_jsx(IconContainer, Object.assign({}, props));